import { Component, OnInit } from '@angular/core';
import { ArticleCategory } from '../shared/models/article-category.model';
import { Router, ActivatedRoute } from '@angular/router';
import { ArticleService } from '../shared/services/article.service';
import { SiteArticle } from '../shared/models/site-article.model';
import { DataService } from '../shared/services/data.service';
import { CategorySectionResolverService } from '../shared/services/resolvers/category-section-resolver.service';
import { StorageService } from '../shared/services/storage.service';
import { AuthService } from '../shared/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { ModalsService } from '../shared/services/modals.service';

@Component({
  selector: 'app-home-test',
  templateUrl: './home-test.component.html',
  styleUrls: ['./home-test.component.css']
})
export class HomeTestComponent implements OnInit {

  homeArticles: SiteArticle[];
  isLoading = false;
  langParam: string;
  bloodGroups: Array<{name: string, level: number}> = [];
  lastUpdate: Date;




  constructor(private router: Router,
              private route: ActivatedRoute,
              private translate: TranslateService,
              private articleService: ArticleService,
              private categoryListener: CategorySectionResolverService,
              private modal: ModalsService,
              private dataService: DataService,
              private storageService: StorageService,
              private auth: AuthService,) { }

  ngOnInit() {
    // this.loadArticles();

    // tslint:disable-next-line: max-line-length
    this.langParam = this.route.snapshot.data.language != null && this.route.snapshot.data.language !== undefined ? this.route.snapshot.data.language.language : 'me';
    this.loadBloodGroups();

  }

  onSupplyButtonClicked() {
    this.modal.modalBloodSupplies.emit(true);
  }

  loadBloodGroups() {

    this.dataService.getDataOutside('https://api.darujkrv.me/zalihe/active').subscribe((resp) => {
      //  console.log(resp);
      const supply = resp;
      this.bloodGroups = [
        {name: 'A+', level: supply.a_plus},
        {name: 'A-', level: supply.a_minus},
        {name: 'B+', level: supply.b_plus},
        {name: 'B-', level: supply.b_minus},
        {name: 'AB+', level: supply.ab_plus},
        {name: 'AB-', level: supply.ab_minus},
        {name: '0+', level: supply.ab_plus},
        {name: '0-', level: supply.ab_minus},
      ];
      this.lastUpdate = new Date(supply.datum);
      this.dataService.bloodSupliesAnimationEvent.emit(true);

      }, (err) => {
        //  console.log(err);
      });
  
    }


}
